import { useState } from 'react';
import { deletePedido } from '../../services/pedidoService';

const useDeletePedido = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const remove = async (id: string) => {
    setLoading(true);
    try {
      await deletePedido(id);
    } catch (err) {
      setError('Falha ao deletar pedido');
    } finally {
      setLoading(false);
    }
  };

  return { deletePedido: remove, loading, error };
};

export default useDeletePedido;
